import React from 'react';

const ProviderLayoutRuntime = ({ children }) => <>{children}</>;

export default ProviderLayoutRuntime;
